import 'es6-promise/auto';
import 'babel-polyfill';
import Config from 'config';
let config;
import React from 'react';
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import isFunction from 'lodash/isFunction';
import { redirectWithMessage, redirectWithError } from 'lib/common/fallbacks';

import AppContainer from 'containers/AppContainer';

function supportsSVG() {
  let div = document.createElement('div');
  div.innerHTML = '<svg/>';
  return (
    (typeof SVGRect != 'undefined' &&
      div.firstChild &&
      div.firstChild.namespaceURI) == 'http://www.w3.org/2000/svg'
  );
}

/**
 * SYOS contructor
 *
 * Requires an options parameter.
 * At the *miniumum*, the options parameter
 * must contain the Tessitura proxy endpoint.
 */
function SYOS(options) {
  if (!options.endpoint) {
    throw new Error('Endpoint not defined');
  }

  this.endpoint = options.endpoint;

  if (!isFunction(options.onComplete)) {
    throw new Error('on complete callback must be provided');
  }

  this.onComplete = options.onComplete;

  /**
   * Initial session key
   */
  this.initialSessionKey = options.initialSessionKey || undefined;

  /**
   * Initial performance number, or package no.
   * If these aren't passed in via the constructor they can also
   * be passed via query string parameters.
   */
  this.initialPerfNo = options.initialPerfNo || undefined;
  this.initialPkgNo = options.initialPkgNo || undefined;

  /**
   * Initial MOS and source code (from LoginInfo)
   */
  this.initialMos = options.initialMos || undefined;
  this.initialPromoCode = options.initialPromoCode || undefined;

  /**
   * SYOS Mode
   */
  this.mode = options.mode || undefined;

  /**
   * Options for flex packages
   */
  this.priceTypeOptions = options.priceTypeOptions || undefined;

  /**
   * Return to this URL on back or availability error
   */
  this.returnUrl = options.returnUrl || '/';
}
SYOS.prototype.run = function(rootEl) {
  let cutsMustard =
    supportsSVG() &&
    'querySelector' in document &&
    'addEventListener' in window &&
    'localStorage' in window &&
    'sessionStorage' in window &&
    'bind' in Function;

  /**
   * Check we are able to run SYOS
   * otherwise redirect to fallback URL
   */
  if (cutsMustard) {
    /**
     * Extract possible query parameters
     *
     * A valid URL contains *either* a performance number (perf_no) *OR* package number (pkg_no).
     *
     * `perf_no`
     * If the seat-map will show availability for a performance.
     * This is the default behaviour.
     *
     * `pkg_no`
     * If set the seat-map will show availability for a package.
     * This is used to allow editing of package level seats.
     *
     * Valid query strings:
     * ?perf_no=1234
     * ?pkg_no=1234
     */
    let parsedQuery = queryString.parse(window.location.search);

    let initialPerformanceId = parseInt(this.initialPerfNo, 10);
    if (initialPerformanceId === undefined) {
      initialPerformanceId = parseInt(parsedQuery.perf_no, 10);
    }

    let packageNo = parseInt(this.initialPkgNo, 10);
    if (packageNo === undefined) {
      packageNo = parseInt(parsedQuery.pkg_no, 10);
    }

    if (!this.initialSessionKey && parsedQuery.session_key) {
      this.initialSessionKey = parsedQuery.session_key;
    }

    if (!this.initialPromoCode && parsedQuery.source_code) {
      this.initialPromoCode = parsedQuery.source_code;
    }

    if (!initialPerformanceId && !packageNo) {
      let err = Error('Performance number required (?perf_no=)');
      redirectWithError(err);
    }

    ReactDOM.render(
      <AppContainer
        endpoint={this.endpoint}
        onComplete={this.onComplete}
        initialSessionKey={this.initialSessionKey}
        initialPerformanceId={initialPerformanceId}
        initialMos={this.initialMos}
        initialPromoCode={this.initialPromoCode}
        packageNo={packageNo}
        queryParams={parsedQuery}
        mode={this.mode}
        priceTypeOptions={this.priceTypeOptions}
        returnUrl={this.returnUrl}
      />,
      rootEl
    );
  } else {
    config = new Config().getConfig();
    redirectWithMessage(config.fallbacks.unsupportedMessage);
  }
};

window.SYOS = SYOS;
export default SYOS;



// WEBPACK FOOTER //
// ./src/javascripts/main.js